import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import { useEffect } from 'react';
import { AuthorizationForm } from '@features/authorization';
import { Button } from '@heroui/react';
import { CloseCircle } from 'iconsax-react';
import { useNavigate } from 'react-router-dom';

export const AuthorizationPage = () => {
  const set = useNavbar();

  const navigate = useNavigate();

  useEffect(() => {
    set.none();
  }, []);

  return (
    <div className="px-4">
      <Button
        radius="full"
        isIconOnly
        variant="light"
        className="fixed top-6 left-4"
        onPress={() => navigate('/')}
      >
        <CloseCircle size="24" color="#9CA5AC" />
      </Button>
      <AuthorizationForm
        onSuccess={() => navigate('/?store=validate', { replace: true })}
      />
    </div>
  );
};
